export const CustomerVehiclesSceneTranslation = {
  fi: {
    CustomerVehiclesScene: {
      title: 'Ajoneuvot: {{name}}',
      totalCount: 'Yhteensä {{count}} ajoneuvoa',
      backToCustomers: 'Takaisin asiakasyrityksiin',
      addVehicle: 'Lisää ajoneuvo',
      addVehicleConfirmTitle: 'Haluatko siirtyä lisäämään uuden ajoneuvon asiakkaalle {{name}}?',
      addVehicleConfirm: 'Lisää ajoneuvo',
      addVehicleCancel: 'Peruuta',
    },
  },
};
